import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { examineServerAdd, examineServerUpd } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onoffs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    examinePkgLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    var version = function version(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInput')));
      } else if (/^\d*\.\d*\.\d*$/.test(value)) {
        callback();
      } else {
        callback(new Error(_this.$t('versionIncorrect')));
      }
    };

    return {
      paramsData: {
        id: '',
        version: '',
        pkgId: '',
        onoff: 1
      },
      dialogShow: false,
      rules: {
        version: [{
          validator: version,
          required: true,
          trigger: "blur"
        }],
        pkgId: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        onoff: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      if (data) {
        this.paramsData = _objectSpread(_objectSpread({}, this.paramsData), data);
      }

      this.dialogShow = true;
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: isClearId ? '' : this.paramsData.id,
        version: this.paramsData.id ? isClearId ? '' : this.paramsData.version : '',
        pkgId: this.paramsData.id ? isClearId ? '' : this.paramsData.pkgId : '',
        onoff: this.paramsData.id ? isClearId ? '' : this.paramsData.onoff : ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.paramsData.id !== '' ? examineServerUpd : examineServerAdd;
          reqFn(_objectSpread(_objectSpread({}, _this2.paramsData), _this2.prod)).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('update');
            }
          });
        }
      });
    }
  }
};